export function parseServiceErrorMessage(message) {
    let parsedMessage = message || "";

    try {
        if (typeof message === "string" && message.startsWith("error:")) {
            const outer = JSON.parse(message.replace("error:", ""));

            if (outer?.detail) {
                let detail = outer.detail;

                if (typeof detail === "string") {
                    try {
                        const inner = JSON.parse(detail);

                        if (inner?.detail?.message) {
                            parsedMessage = inner.detail.message;
                        } else if (inner?.detail) {
                            parsedMessage = inner.detail;
                        } else {
                            parsedMessage = detail;
                        }
                    } catch {
                        parsedMessage = detail;
                    }
                } else if (typeof detail === "object") {
                    parsedMessage = detail.message || JSON.stringify(detail);
                }
            }
        }
    } catch (error) {
        console.error("Error parsing service error message:", error);
    }

    return parsedMessage;
}